import React from "react";
import { View, Text, TouchableOpacity, Pressable, Image } from 'react-native';
import { CreateResponsiveStyle } from "rn-responsive-styles";
import CloseIcon from "../../assets/images/icon_close.png";
import CView from "./CView";

const ChooseImage=(props)=>{

    const frontFile = props?.imageData?.img
    const previewFile = props?.imageData?.preview
    const styles = useStyles();
    const imageId = props?.id;
    const label = props?.label 

    const handleImageClick  = (event,id)=>{
        event.preventDefault();
        let element = document.getElementById(id);
        element.click();
    }
      const onImageChange = (event)=>{
        const file = event.target.files[0];
        var sizeInMB = (file.size / (1024 * 1024)).toFixed(2);
        const maxFileSize = global?.maxUploadFileSizeInMB;
        if (file) {
          if (sizeInMB > maxFileSize) {
            props.setAlertModal({
              title: "Error",
              status: "error",
              message: `Kindly upload Jpeg images upto ${maxFileSize} MB`,
              navigateScreen: "",
              actionButton: "OK",
            });
            props.setAlertModalVisible(true);
          } else if (file.type == "image/jpeg") {
            setImage(file)
          } else {
            props.setAlertModal({
              title: "Error",
              status: "error",
              message: "Kindly upload Jpeg images only",
              navigateScreen: "",
              actionButton: "OK",
            });
            props.setAlertModalVisible(true);
          }
        } 
      }
      const setImage = (file)=>{
        let reader = new FileReader();
        reader.onloadend = () => {
        };
        reader.readAsDataURL(file);
        props.setImage(imageId,file)
       
      }
      const clearImage = ()=>{
        props?.onCancel(imageId)
      }
    
    return  <View >
    <CView H90 MT={20} >
        {frontFile && previewFile ? 
        <View style={styles.imageStyle}>
          <TouchableOpacity
            onPress={() =>  clearImage()}
            style={styles.closeIconLink}>
            <Image
              source={CloseIcon}
              style={styles.closeIcon}
            />
          </TouchableOpacity>
          <Image
            source={previewFile}
            style={{ width: 135, height: 135, borderRadius: 10 }}
          />
        </View>
        :
        <Pressable
          style={styles.RCUpdate_ImageUploader}
          onPress={(e)=>{handleImageClick(e,imageId)}}>
          <View style={styles.RCUpdate_ImageUploader_InnerContainer}>
            <Text style={styles.RCUpdate_ImageUploader_PlusIcon}>+</Text>
            <Text style={styles.RCUpdate_ImageUploader_AddText}>{label}</Text>
          </View>
        </Pressable>}
        <View>
        <input
         type='file'
         onChange = {(e)=>onImageChange(e)}
         style={{ display: 'none' }}
         id={imageId}
         accept='image/*'
       />
     </View>
    </CView>
  </View>

}
const useStyles = CreateResponsiveStyle({
    

    RCUpdate_UploadImageContainer: {
      flexDirection: "row",
      height: 90,
      marginTop: 20,
    },
    RCUpdate_ImageUploader: {
      border: "1.5px dashed #ccd0d5",
      borderRadius: 10,
      height: 135,
      width: 135,
      marginRight: 15,
      backgroundColor: "#ffffff",
      marginLeft:10
    },
    RCUpdate_ImageUploader_InnerContainer: {
      width: "100%",
      height: "100%",
      justifyContent: "space-evenly",
      alignItems: "center",
      textAlign: "center",
      paddingBottom: 10,
    },
    RCUpdate_ImageUploader_PlusIcon: {
      fontSize: 35,
      color: "#02122c",
      opacity: "47%",
    },
    RCUpdate_ImageUploader_AddText: {
      fontSize: 11,
      fontFamily: "Inter",
      color: "#02122c",
      opacity: "47%",
    },
    closeIconLink: {
      position: "absolute",
      top: -12,
      right: -20,
      zIndex: 9,
    },
    closeIcon: {
      width: 89,
      height: 89,
    },
    imageStyle: {
      width: 135,
      height: 135,
      fontSize: "1rem",
      color: "white",
      backgroundColor: "#fff",
      borderRadius: 10,
      borderWidth: 1,
      borderStyle: "dashed",
      borderColor: "#ccd0d5",
      alignItems: "center",
      flexDirection: "column",
      justifyContent: "center",
      marginRight:15,
      marginLeft:10
    },
  
  
  });
export default ChooseImage









